<div class="logo-container"  (click)="navigateHome()">
  <img src="/assets/zpax-mini-logo.png" class="zpax-logo">
  <img class="rc-logo" src="/assets/rc-logo.png">
</div>
